export default "__VITE_ASSET__74cc8053__"